// extracted by mini-css-extract-plugin
module.exports = {"Markdown":"Markdown_Markdown__kIRZG"};